export const DISABLE_MEMBER = 'DISABLE_MEMBER';
export const DOWNLOAD_IMPORTING_RESULT = 'DOWNLOAD_IMPORTING_RESULT';
export const ENABLE_MEMBER = 'ENABLE_MEMBER';
export const GET_ACTIVE_MEMBERS = 'GET_ACTIVE_MEMBERS';
export const GET_IMPORTING_RECORD = 'GET_IMPORTING_RECORD';
export const GET_MEMBER_INFO = 'GET_MEMBER_INFO';
export const GET_MEMBER_LIST = 'GET_MEMBER_LIST';
export const GET_MEMBER_ORDERS = 'GET_MEMBER_ORDERS';
export const IMPORT_MEMBERS = 'IMPORT_MEMBERS';
export const INVITE_MEMBER = 'INVITE_MEMBER';
export const IS_GETTING_ACTIVE_MEMBERS = 'IS_GETTING_ACTIVE_MEMBERS';
export const IS_GETTING_MEMBER_LIST = 'IS_GETTING_MEMBER_LIST';
export const REVERIFY_MEMBER = 'REVERIFY_MEMBER';
export const SET_MEMBERS = 'SET_MEMBERS';
export const SORT_WITH_SELECTED_MEMBER = 'SORT_WITH_SELECTED_MEMBER';
export const UPDATE_MEMBER = 'UPDATE_MEMBER';
